import { SearchAdapter } from "VSS/Search";

/**
 * Search adapter to not apply any transformation on the search results
 */
export class NoTranformSearchAdapter<T> extends SearchAdapter<T> {
    /**
     * override handle results to no op
     */
    public handleResults(results: T[], finished: boolean, query: string) {
    }

    /**
     * assume the data is already provided in strategy or added through search core
     */
    public isDataSetComplete(): boolean {
        return true;
    }
}